export const toNormalRepresentation = (number) => {
    if (typeof number !== 'number') {
        throw new Error('Input must be a number');
    }
    // Convert the number to a string in fixed-point notation
    return number.toFixed(5).replace(/0+$/, '').replace(/\.$/, '');
};
